import { render } from "./DashboardProcurement.vue?vue&type=template&id=b44ad0f8&scoped=true"
import script from "./DashboardProcurement.vue?vue&type=script&lang=js"
export * from "./DashboardProcurement.vue?vue&type=script&lang=js"

import "./DashboardProcurement.vue?vue&type=style&index=0&id=b44ad0f8&scoped=true&lang=css"
import "./DashboardProcurement.vue?vue&type=style&index=1&id=b44ad0f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b44ad0f8"]])

export default __exports__